import React from 'react';
import { Text, Flex } from '@spothero/ui';
import FormatUtils from 'utils/format';
const RefundInfo = ({ refundAmount, onlyOriginalPaymentView, onlyCreditView, }) => {
    const chargeAmount = FormatUtils.price(refundAmount.charge).displayPrice;
    const creditAmount = FormatUtils.price(refundAmount.credit).displayPrice;
    if (onlyOriginalPaymentView) {
        return (<>
                <Flex marginTop={4} flexDirection="column">
                    <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                        Refund Amount
                    </Text>
                    <Text>${chargeAmount}</Text>
                </Flex>

                <Text marginTop={6} fontSize="sm">
                    Your refund will be sent to your original payment method. It
                    typically takes 5-10 business days for it to appear on your
                    payment method.
                </Text>
            </>);
    }
    if (onlyCreditView) {
        return (<>
                <Flex marginTop={4} flexDirection="column">
                    <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                        Refund Amount
                    </Text>
                    <Text>${creditAmount}</Text>
                </Flex>

                <Text marginTop={6} fontSize="sm">
                    This reservation was made using SpotHero credit, so your
                    refund will be issued immediately as SpotHero credit.
                </Text>
            </>);
    }
    if (refundAmount.credit > 0) {
        return (<>
                <Flex marginTop={4} flexDirection="column">
                    <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                        SpotHero Credit to Refund
                    </Text>
                    <Text>${creditAmount}</Text>
                </Flex>
                <Flex marginTop={4} flexDirection="column">
                    <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                        Remaining to Refund
                    </Text>
                    <Text>${chargeAmount}</Text>
                </Flex>
            </>);
    }
    return (<Flex marginTop={4} flexDirection="column">
            <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                Refund Amount
            </Text>
            <Text>${chargeAmount}</Text>
        </Flex>);
};
export default RefundInfo;
